import { sessionStorageKeyConstants } from '../../constants/session-storage-key-constants'
import { getHeaders } from '../axios/axios-helpers'
import HttpClient from '../axios/http-client'

export function getAllPermissions(request) {
  const idToken = sessionStorage.getItem(sessionStorageKeyConstants.ID_TOKEN)
  const headers = getHeaders(idToken)
  if (request) headers['App-Name'] = request
  else delete headers['App-Name']
  const httpClient = new HttpClient(headers)
  const userInstance = httpClient.userInstance()
  return userInstance.get('/permissions')
}

export function getAllPermissionsByRole(request) {
  const { appName, role } = request
  const idToken = sessionStorage.getItem(sessionStorageKeyConstants.ID_TOKEN)
  const headers = getHeaders(idToken)
  headers['App-Name'] = appName
  headers.Role = role
  const httpClient = new HttpClient(headers)
  const userInstance = httpClient.userInstance()
  return userInstance.get('/permissions/role')
}
